import { Attributes, Rules, Validation } from '@singularsystems/neo-core';
import TemporalEntity from '../../TemporalEntity';
import BankDetail from '../../ValueObjects/BankDetail';

export default class InvestorReferralType extends TemporalEntity {
    static typeName = "InvestorReferralType";

    constructor() {
        super();
        this.makeObservable();
    }

    public investorReferralTypeId: number = 0;

    @Rules.StringLength(50)
    @Rules.Required()
    @Attributes.Display("Investor Referral Type")
    public investorReferralTypeName: string = "";

    @Rules.StringLength(500)
    public agreementFooter: string = "";

    @Rules.StringLength(250)
    public physicalAddress: string = "";

    @Rules.StringLength(250)
    public postalAddress: string = "";

    @Rules.StringLength(100)
    @Attributes.Display("Phone Numbers")
    public phoneNos: string = "";

    @Attributes.ChildObject(BankDetail, true)
    public bankDetails: BankDetail | null = null;

    @Attributes.Float()
    public minimumLimit: number = 0.00;

    public mist: boolean = false;

    @Attributes.Display("CIS Number")
    @Rules.StringLength(12)
    public cisNumber: string = "";

    public requiresExternalAccountNo: boolean = false;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.investorReferralTypeName) {
            return "New investor referral type";
        } else {
            return this.investorReferralTypeName;
        }
    }
}